export default __webpack_public_path__ + "static/media/MTRG-BUSD.37bee970.svg";